import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import {
  utilCreateCategoriaMenu,
  saveImageToFirebaseStorage,
  utilUpdateCategoriaMenu,
  utilDeleteCategoriaMenu,
  utilDeleteAllPlatillosCategoria,
} from "../../../../util/UtilsFirebase";

import Switch from "react-switch";

import { useAuthContext } from "../../../../hooks/useAuthContext";

import "./CategoriaModal.css";

const CategoriaModal = ({
  menu,
  showCategoria,
  mod,
  itemCategoria,
  handleCloseCategoria,
}) => {
  const { register } = useAuthContext();

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [categoria, setCategoria] = useState({
    img: null,
    name: "",
    active: true,
  });
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {
    if (showCategoria) {
      if (mod) {
        setCategoria(itemCategoria);
        setImageUrl(itemCategoria.img);
        if (mod === "DLT") {
          setIsDelete(true);
        } else {
          setIsDelete(false);
        }
      }
    }
  }, [itemCategoria, mod, showCategoria]);

  const handleChange = (e) => {
    setCategoria({
      ...categoria,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSwitch = (e) => {
    setCategoria({
      ...categoria,
      active: e,
    });
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];

      // Read the image file and create a preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleCloseLocal = async () => {
    //setCategoria(null);
    setImageUrl(null);
    setImage(null);
    handleCloseCategoria();
  };

  const saveCategoria = async () => {
    let downloadURL = "";

    if (mod === "ADD") {
      if (!image) {
        alert("Seleccione una imagen");
        return;
      }

      const categoriaReg = await utilCreateCategoriaMenu(menu.id, categoria);

      let path = "";

      path = "truck/" + register.id + "/menu/categoria/";

      downloadURL = await saveImageToFirebaseStorage(path, image);

      if (downloadURL) {
        setImageUrl(downloadURL);
      }

      categoriaReg.img = downloadURL;

      console.log(categoriaReg);

      utilUpdateCategoriaMenu(menu.id, categoriaReg);

      //setCategoria(null);
      setImage(null);
      setImageUrl(null);
      handleCloseCategoria();
    }

    if (mod === "UPD") {
      if (image) {
        let path = "";

        path = "truck/" + register.id + "/menu/categoria/";

        downloadURL = await saveImageToFirebaseStorage(path, image);

        if (downloadURL) {
          setImageUrl(downloadURL);
        }

        categoria.img = downloadURL;
      }

      utilUpdateCategoriaMenu(menu.id, categoria);
      //setCategoria(null);
      setImage(null);
      setImageUrl(null);
      handleCloseCategoria();
    }

    if (mod === "DLT") {
      utilDeleteCategoriaMenu(menu.id, categoria);
      utilDeleteAllPlatillosCategoria(menu.id, categoria.id);
      setImage(null);
      setImageUrl(null);
      handleCloseCategoria();

      // Esta linea unicamente la utilizo para pruebas e identificar el id del menu relacionado al platillo que se esta eliminado.
      //alert("Menu ID: " + menu.id)
      //alert("Categoria ID: " + categoria.id);
    }
  };

  return (
    <Modal show={showCategoria} onHide={handleCloseCategoria} size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          {mod && mod === "ADD" ? "AGREGAR" : ""}{" "}
          {mod && mod === "UPD" ? "MODIFICAR" : ""}{" "}
          {mod && mod === "DLT" ? "ELIMINAR" : ""} CATEGORIA
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form>
                {mod && mod === "DLT" ? (
                  <Row>
                    <Col md={12}>
                      <label htmlFor="">
                        ¿Esta seguro de borrar Categoria con todo y Platillos?
                      </label>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}

                <Row>
                  <Col md={12}>
                    <Form.Group controlId="razonSocial">
                      <Form.Label>Nombre categoria:</Form.Label>
                      <Form.Control
                        disabled={isDelete}
                        onChange={handleChange}
                        value={categoria?.name}
                        name="name"
                        required
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}></Col>
                  <Col md={6}>
                    <div className="center">
                      <label htmlFor="active" className="mrg-lblshow">
                        MOSTRAR
                      </label>
                      <Switch
                        id="active"
                        disabled={isDelete}
                        onChange={handleChangeSwitch}
                        checked={categoria?.active}
                      />
                    </div>
                  </Col>
                  <Col md={3}></Col>
                </Row>

                <div className="center-form">
                  <div className=" offset-sm-12 col-sm-12 center">
                    <Form.Group controlId="img">
                      <label>
                        <img
                          alt=""
                          id="logo_img"
                          src={imageUrl}
                          height="92"
                          width="132"
                        />
                        <input
                          id="logoNeg"
                          type="file"
                          disabled={isDelete}
                          style={{ display: "none" }}
                          accept="image/png"
                          multiple={false}
                          onChange={handleImageChange}
                        />
                      </label>
                    </Form.Group>

                    {mod && mod !== "DLT" ? (
                      <label>Click para seleccionar imagen.</label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={saveCategoria}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CategoriaModal;
